export default __webpack_public_path__ + "static/skirt-length-2b4eebc4723b5bc6b9048202eea56a20.svg";